/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name reportdatepicker
 * @description Displays a datepicker to allow the user to update the report time. Also includes the pagetitle
 * @attr {Boolean} show-print-link Show a print page link below the pagetitle
 */
angular.module('mercury.directives.reportdatepicker', [])
.directive('reportdatepicker', ["comparetime", "$parse", "$location", "reporttime", "$state", "$stateParams", "$timeout", function(comparetime, $parse, $location, reporttime, $state, $stateParams, $timeout) {
  return {
    templateUrl: 'directives/reportdatepicker/reportdatepicker.tpl.html',
    restrict: 'A',
    replace: true,
    scope: true,
    transclude: true,
    link: function(scope, element, attrs) {
      scope.closed = true;

      //Testing adding a flag to help with time change when analyising same day reports.
      if (typeof $state.dateSetTimeAdjusted == 'undefined') {
        $state.dateSetTimeAdjusted = false; //Initiate dateSet;
      }

      if (typeof $state.sameDay == 'undefined') {
        $state.sameDay = false;
      }

      /**
      * Parse the input attributes into a report object
      * Report Object: {
      *		time: ISO date - Core report time passed in route
      *		type: ENUM {Day, Week, Month} - Report type Day, Week, Month
      *		start: ISO date - The start of the report period
      *		end: ISO date - The end of the report period
      * }
      */
      scope.report = reporttime.params(['start', 'end', 'type', 'time']);
      scope.compare = comparetime.params(['start', 'end', 'time']);
      scope.compareEnabled = scope.compare !== null;
      scope.compareAvaliable = Object.keys($stateParams).indexOf('compare') !== -1;

      scope.pageReport = angular.copy(scope.report);

      scope.allowedTypes = reporttime.getAllowedTypes();

      scope.superMap = {
        day: 'week',
        week: 'month',
        month: 'year'
      };

      //Track which date should be changed by the next select.
      scope.customReportSelect = 'start';
      scope.customCompareSelect = 'start';

      scope.applyDate = function() {

        var stateParams = {
          report: JSON.stringify(scope.report),
          compare: scope.compare ? JSON.stringify(scope.compare) : null
        };

        $state.go($state.current.name, stateParams);
        scope.closed = true;

      };

      scope.resetToSameDay = function() {
        a = moment(scope.report.start);
        b = moment(scope.report.end).subtract(1, 'day');

        //if the minutes between the start time and end time is greater than zero, then remove one day from the end date.
        if (b.diff(a, 'minutes') > 0) {
          scope.report.end = moment(scope.report.end).subtract(1, 'day');
        }
      };

      scope.dateTimeAdjust = function() {

        //Check the state for the same day selection.
        if ($state.sameDay) {
          //If the end date is not equal to the start date then set it back to same date.
          if (moment(scope.report.start).format('D') != moment(scope.report.end).format('D')) {
            scope.resetToSameDay();
          }
        } else {
          if ($state.dateSetTimeAdjusted == false &&
            //If the end date is not equal to the start date then set it back to same date & set state flag for Adjusting the dateSetTimeAdjusted
            moment(scope.report.end).mStartOf('day').format('h') != moment(scope.report.end).format('h')
            ) {
            scope.resetToSameDay();
            $state.dateSetTimeAdjusted = true;
          }
        }

        //If the end date is before the start date then add one day to the end date.
        if (moment(scope.report.end).isBefore(scope.report.start)) {
          scope.report.end = moment(scope.report.start).add(1, 'day').format();
        }

      };

      //Watch the Start Date/Time for changes. If the time has changed then adjust the date/time picker accordingly.
      scope.$watch('report.start', function(newValue, oldValue, scope) {
        if (moment(newValue).format('HH:mm') != moment(oldValue).format('HH:mm')) {
          scope.dateTimeAdjust();
        }
      });

      //Watch the End Date/Time for changes. If the time has changed then adjust the date/time picker accordingly.
      scope.$watch('report.end', function(newValue, oldValue, scope) {
        if (moment(newValue).format('HH:mm') != moment(oldValue).format('HH:mm')) {
          scope.dateTimeAdjust();
        }
      });

      /**
      * Helper function to add a class to the datepicker day that matches the input date
      *
      * @param {String} datepicker - The jquery element that contains the target datepicker
      * @param {String} date - the date to add the class to within the datepicker
      * @param {String} dayClass - The class to add. If undefined will defaut to ui-state-active
      */
      var addDayClass = function(datepicker, date, dayClass) {
        datepicker
          .find('td[data-year="' + date.year() + '"][data-month="' + date.month() + '"]')
          .each(function() {
            if ($(this).find('a').html() == date.date()) {
              $(this).find('a').addClass(dayClass);
            }
          });
      };

      /**
      * Function to update the UI to hightlight the correct dates on the datepicker to show report and compare times
      */
      var highlightDates = function() {
        $('.ui-state-active').removeClass('ui-state-active');

        $('.dp-active').removeClass('dp-active');
        $('.dp-inactive').removeClass('dp-inactive');

        for (var dateIter = moment(scope.report.start).clone(); dateIter.isBefore(scope.report.end); dateIter.add(1, 'days')) {
          addDayClass($('#dp'), dateIter, 'dp-active');
        }

        if (scope.compare) {
          for (var compareIter = moment(scope.compare.start).clone(); compareIter.isBefore(scope.compare.end); compareIter.add(1, 'days')) {
            addDayClass($('#dp-compare'), compareIter, 'dp-active');
          }
        }

        $('.ui-datepicker-calendar tr').on('mousemove', function() {
          if (scope.report.type == 'month') {
            $(this).parent().find('a:not(.ui-state-active)').addClass('ui-state-hover');
          } else if (scope.report.type == 'week') {
            $(this).find('a:not(.ui-state-active)').addClass('ui-state-hover');
          }
        });

        $('.ui-datepicker-calendar tr').on('mouseleave', function() {
          if (scope.report.type == 'month') {
            $(this).parent().find('a:not(.ui-state-active)').removeClass('ui-state-hover');
          } else if (scope.report.type == 'week') {
            $(this).find('a:not(.ui-state-active)').removeClass('ui-state-hover');
          }
        });
      };

      scope.changeCompare = function() {
        if (scope.compareEnabled) {
          var compareTime = moment(scope.report.time).subtract(1, scope.report.type).format();

          if (scope.report.type == 'custom') {
            scope.compare = {
              time: scope.report.time,
              start: scope.report.start,
              end: scope.report.end
            };
          } else {
            scope.compare = {
              time: compareTime,
              start: moment(compareTime).mStartOf(scope.report.type).format(),
              end: moment(compareTime).mStartOf(scope.report.type).add(1, scope.report.type).format()
            };
          }
        } else {
          scope.compare = null;
        }

        $timeout(highlightDates);
      };

      /**
      * Callback for then the report period is changed. Reset the compare range if compare mode is active, then
      * update the start and end times
      */
      scope.setPeriod = function() {
        if (scope.report.type != 'custom') {
          scope.report.start = moment(scope.report.time).mStartOf(scope.report.type).format();
          scope.report.end = moment(scope.report.time).mStartOf(scope.report.type).add(1, scope.report.type).format();

          if (scope.compare) {
            scope.compare.time = moment(scope.report.time).subtract(1, scope.report.type).format();
            scope.compare.start = moment(scope.compare.time).mStartOf(scope.report.type).format();
            scope.compare.end = moment(scope.compare.time).mStartOf(scope.report.type).add(1, scope.report.type).format();
          }
        }

        $timeout(highlightDates);
      };

      /**
      * Callback for the 'next' quick jump buttons. Alter the report and compare times and apply the date to the report
      *
      * @param {bool} largeIncrement - Was the next button that was clicked, the super increment (i.e week>> on day report)
      */
      scope.quickNext = function(largeIncrement) {
        var increment = scope.quickType(largeIncrement);

        scope.report.time = moment(scope.report.time).add(1, increment).format();
        scope.report.start = moment(scope.report.start).add(1, increment).format();
        scope.report.end = moment(scope.report.end).add(1, increment).format();

        if (scope.compare) {
          scope.compare.time = moment(scope.compare.time).add(1, increment).format();
          scope.compare.start = moment(scope.compare.start).add(1, increment).format();
          scope.compare.end = moment(scope.compare.end).add(1, increment).format();
        }

        scope.applyDate();
      };

      /**
      * Callback for the 'previous' quick jump buttons. Alter the report and compare times and apply the date to the report
      *
      * @param {bool} largeIncrement - Was the next button that was clicked, the super increment (i.e week>> on day report)
      */
      scope.quickPrev = function(largeIncrement) {
        var increment = scope.quickType(largeIncrement);

        scope.report.time = moment(scope.report.time).subtract(1, increment).format();
        scope.report.start = moment(scope.report.start).subtract(1, increment).format();
        scope.report.end = moment(scope.report.end).subtract(1, increment).format();

        if (scope.compare) {
          scope.compare.time = moment(scope.compare.time).subtract(1, increment).format();
          scope.compare.start = moment(scope.compare.start).subtract(1, increment).format();
          scope.compare.end = moment(scope.compare.end).subtract(1, increment).format();
        }

        scope.applyDate();
      };

      scope.quickType = function(largeIncrement) {
        if (reporttime.reportType() == 'custom') {
          var daysLength = moment(reporttime.end()).diff(reporttime.start(), 'days');

          var increment;
          if (daysLength <= 1) {
            increment = 'day';
          } else if (daysLength <= 7) {
            increment = 'week';
          } else {
            increment = 'month';
          }

          return (largeIncrement) ? scope.superMap[increment] : increment;
        } else {
          return (largeIncrement) ? scope.superMap[reporttime.reportType()] : reporttime.reportType();
        }
      };

      scope.reportDateHeader = function() {
        if (reporttime.reportType() == 'day') {
          return moment(reporttime.start()).format('dddd, Do MMMM YYYY');
        } else {
          var startMoment = moment(reporttime.start());
          var endMoment = moment(reporttime.end());

          var startFormat = (startMoment.isSame(startMoment.clone().mStartOf('day')) && scope.report.type != 'custom') ?
            'MMM D YYYY' : 'MMM D YYYY, h:mma';
          var endFormat = (endMoment.isSame(endMoment.clone().mStartOf('day')) && scope.report.type != 'custom') ?
            'MMM D YYYY' : 'MMM D YYYY, h:mma';

          return startMoment.format(startFormat) + ' - ' + endMoment.format(endFormat);
        }
      };

      scope.compareDateHeader = function() {
        if (!comparetime.time()) {
          return '';
        } else if (reporttime.reportType() == 'day') {
          return 'Compared With ' + moment(comparetime.start()).format('dddd, Do MMMM YYYY');
        } else {
          var startMoment = moment(comparetime.start());
          var endMoment = moment(comparetime.end());

          var startFormat = (startMoment.isSame(startMoment.clone().mStartOf('day'))) ?
            'MMM D YYYY' : 'MMM D YYYY, h:mma';
          var endFormat = (endMoment.isSame(endMoment.clone().mStartOf('day'))) ?
            'MMM D YYYY' : 'MMM D YYYY, h:mma';

          return 'Compared With ' + startMoment.format(startFormat) + ' - ' + endMoment.format(endFormat);
        }
      };

      /**
      * Callback for opening or closing the datepicker.
      */
      scope.toggleDatepicker = function() {
        scope.closed = !scope.closed;

        if (!scope.closed) {
          scope.report = reporttime.params(['start', 'end', 'type', 'time']);
          scope.compare = comparetime.params(['start', 'end', 'time']);

          highlightDates();
        }
      };

      var getNumberMonths = function() {
        var width = $(window).width();
        if (width > 1200) {
          return 3;
        } else if (width > 768) {
          return 2;
        } else {
          return 1;
        }
      };

      /**
      * Initial setup function. Initialises the JQuery date picker and highlights the inital date selection
      */
      $timeout(function() {
        $('#dp').datepicker({
          numberOfMonths: getNumberMonths(),
          firstDay: reporttime.weekStart,
          defaultDate: moment(scope.report.start).format('MM/DD/YYYY'),
          onChangeMonthYear: function() {
            $timeout(highlightDates);
          },
          onSelect: function(date) {
            var dateSelected = moment(date, 'MM/DD/YYYY').add(1, 'day').mStartOf('day').format();

            if (scope.report.type != 'custom') {
              scope.report.time = dateSelected;

              scope.report.start = moment(scope.report.time).mStartOf(scope.report.type).format();
              scope.report.end = moment(scope.report.time).mStartOf(scope.report.type).add(1, scope.report.type).format();
            } else if (scope.customReportSelect == 'start') {

              $state.dateSetTimeAdjusted = false;

              scope.report.time = dateSelected;
              scope.report.start = dateSelected;

              if (moment(scope.report.end).isBefore(scope.report.start)) {
                scope.report.end = moment(scope.report.start).add(1, 'day').format();
              }

              scope.customReportSelect = 'end';
            } else {

              $state.dateSetTimeAdjusted = false;

              if (scope.report.start == dateSelected) {
                $state.sameDay = true;
                scope.report.end = moment(dateSelected).mEndOf('day').format();
              } else {
                $state.sameDay = false;
                scope.report.end = moment(dateSelected).add(1, 'day').format();
              }

              if (moment(scope.report.start).isAfter(scope.report.end)) {
                scope.report.start = moment(scope.report.end).subtract(1, 'day').format();
              }

              scope.customReportSelect = 'start';
            }

            $timeout(highlightDates);
          }
        });

        $('#dp-compare').datepicker({
          numberOfMonths: getNumberMonths(),
          firstDay: reporttime.weekStart,
          defaultDate: moment(scope.compare ? scope.compare.start : scope.report.start).format('MM/DD/YYYY'),
          onChangeMonthYear: function() {
            $timeout(highlightDates);
          },
          onSelect: function(date) {
            var dateSelected = moment(date, 'MM/DD/YYYY').add(1, 'day').mStartOf('day').format();

            if (scope.report.type != 'custom') {
              scope.compare.time = dateSelected;

              scope.compare.start = moment(scope.compare.time).mStartOf(scope.report.type).format();
              scope.compare.end = moment(scope.compare.time).mStartOf(scope.report.type).add(1, scope.report.type).format();
            } else if (scope.customCompareSelect == 'start') {
              scope.compare.time = dateSelected;
              scope.compare.start = dateSelected;

              if (moment(scope.compare.end).isBefore(scope.compare.start)) {
                scope.compare.end = moment(scope.compare.start).add(1, 'day').format();
              }

              scope.customCompareSelect = 'end';
            } else {
              // scope.compare.end = moment(dateSelected).add(1, 'day').format();
              scope.compare.end = dateSelected;

              if (moment(scope.compare.start).isAfter(scope.compare.end)) {
                scope.compare.start = moment(scope.compare.end).subtract(1, 'day').format();
              }

              scope.customCompareSelect = 'start';
            }

            $timeout(highlightDates);
          }
        });

        $(window).resize(function() {
          $('#dp,#dp-compare').datepicker('option', {numberOfMonths: getNumberMonths()});

          $timeout(highlightDates);
        });
      });

      if (attrs.showPrintLink) {
        scope.printLink = true;
      }

      scope.print = function() {
        window.print();
      };
    }
  };
}]);
